import { store } from "../store";

export const toggleActivateKozijnColor = () => {
  store.activateKozijnColor = !store.activateKozijnColor;
};

export const disableKozijnColor = () => {
  store.activateKozijnColor = false;
};

export const enableKozijnColor = () => {
  store.activateKozijnColor = true;
};
